var _desc, _defs, _clipPath;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitHub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.72 0 0 4.72 330.97 271.84)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 8,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 40
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.29 0 0 2.29 333.03 265.59)",
    clipPath: "url(#CLIPPATH_73)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_73"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -0.48 3.08)",
    x: -96,
    y: -96,
    rx: 0,
    ry: 0,
    width: 192,
    height: 192
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(23,22,21)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-96.48, -95.7)",
    d: "M 96.365 2.49061 C 73.6183 2.40481 51.5876 10.4394 34.2366 25.1486 C 16.8856 39.8579 5.3533 60.2764 1.71461 82.7303 C -1.92408 105.184 2.56976 128.2 14.3875 147.636 C 26.2052 167.072 44.5709 181.653 66.1806 188.755 C 70.9566 189.614 72.6761 186.701 72.6761 183.979 C 72.6761 181.256 72.6761 174.427 72.6761 166.164 C 46.1215 171.991 40.5335 154.893 40.5335 154.893 C 38.766 149.108 34.9885 144.144 29.883 140.899 C 21.2384 134.977 30.5517 135.12 30.5517 135.12 C 33.5875 135.542 36.4868 136.652 39.028 138.365 C 41.5693 140.079 43.6852 142.35 45.214 145.007 C 53.7153 159.335 67.5656 155.371 73.0103 152.935 C 73.4503 148.084 75.6002 143.547 79.0759 140.135 C 57.8704 137.747 35.5187 129.532 35.5187 92.9003 C 35.4099 83.401 38.9482 74.2217 45.405 67.2532 C 42.4835 59.0226 42.808 49.9881 46.3124 41.9883 C 46.3124 41.9883 54.3361 39.4092 72.5804 51.8268 C 88.2127 47.5458 104.708 47.5458 120.34 51.8268 C 138.585 39.457 146.561 41.9883 146.561 41.9883 C 150.071 49.9842 150.413 59.0151 147.516 67.2532 C 153.96 74.2264 157.481 83.4067 157.355 92.9003 C 157.355 129.628 135.003 137.699 113.702 140.039 C 115.994 142.355 117.763 145.134 118.892 148.191 C 120.02 151.247 120.482 154.509 120.245 157.759 C 120.245 170.558 120.245 180.827 120.245 183.979 C 120.245 187.131 121.964 189.471 126.788 188.755 C 148.398 181.653 166.764 167.072 178.581 147.636 C 190.399 128.2 194.893 105.184 191.254 82.7303 C 187.615 60.2764 176.083 39.8579 158.732 25.1486 C 141.381 10.4394 119.35 2.40481 96.6037 2.49061",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHub);
export default __webpack_public_path__ + "static/media/GitHub.bf5ddfed153af3680956c13056178540.svg";
export { ForwardRef as ReactComponent };